import { createFileRoute } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";
import { useSuspenseGraphQL } from "@/hooks/use-graphql.ts";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { SecretaryDetailsRestrictionsForm } from "@/components/assist/secretary-details/restrictions-form";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetSecretaryRestrictionsQuery = graphql(/* GraphQL */ `
  query GetSecretaryRestrictionsQuery {
    ...SecretaryDetailsRestrictionsFormFragment
  }
`);

const RestrictionsPage = (): React.ReactNode => {
  const { data } = useSuspenseGraphQL(GetSecretaryRestrictionsQuery, {});
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="" align="center" />
      </HeaderRoot>
      <Page>
        <SecretaryDetailsRestrictionsForm data={data} />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/secretary-details/restrictions")({
  component: RestrictionsPage,
  pendingComponent: () => <PendingComponent title="" />,
});
